export const ACCESS_STORE = 'access'
export const ACTIVATED_STORE = 'activated'
export const ADMIN_STORE = 'admin'
export const ANNOTATION_STORE = 'annotation'
export const AUDIO_STORE = 'audio'
export const BANNER_STORE = 'banner'
export const DOTS_STORE = 'dots'
export const DOTS_SLIDE_STORE = 'dotsSlide'
export const ENTRANCE_STORE = 'entrance'
export const ERROR_STORE = 'error'
export const FOCUS_STORE = 'focus'
export const HOVER_STORE = 'hover'
export const LYRIC_STORE = 'lyric'
export const OPTION_STORE = 'option'
export const PLAYERS_STORE = 'players'
export const PROMO_STORE = 'promo'
export const SCENE_STORE = 'scene'
export const SCROLL_CAROUSEL_STORE = 'scrollCarousel'
export const SCROLL_LYRIC_STORE = 'scrollLyric'
export const SELECTED_STORE = 'selected'
export const SESSION_STORE = 'session'
export const SLIDER_STORE = 'slider'
export const TOGGLE_STORE = 'toggle'
export const TRANSIENT_STORE = 'transient'
export const VERSE_BARS_STORE = 'verseBars'
export const VIEWPORT_STORE = 'viewport'

export const IS_ACCESS_ON = 'isAccessOn'
export const IS_CAROUSEL_EXPANDED = 'isCarouselExpanded'
export const SELECTED_DOTS_BIT = 'selectedDotsBit'
export const IS_TEXT_JUSTIFIED = 'isTextJustified'

export const SELECTED_SONG_INDEX = 'selectedSongIndex'
export const SELECTED_VERSE_INDEX = 'selectedVerseIndex'
export const SELECTED_ANNOTATION_INDEX = 'selectedAnnotationIndex'

export const IS_SONG_REPEAT_ON = 'isSongRepeatOn'
export const VOLUME_INDEX = 'volumeIndex'
export const SELECTED_OVERVIEW_OPTION = 'selectedOverviewOption'
export const SELECTED_TIPS_OPTION = 'selectedTipsOption'
